import type { FrameQuestionParams, FrameQuestionState } from '../types';

interface Props {
  params: FrameQuestionParams;
  puzzleState: FrameQuestionState;
  onSolve: () => void;
  onGrantItem: (itemId: string) => void;
  patchState: (updater: (prev: FrameQuestionState) => FrameQuestionState) => void;
}

export function FrameQuestion({ params, puzzleState, onSolve, onGrantItem, patchState }: Props) {
  const { options, correctOptionId, grantsItem } = params;
  const { selectedOptionId, solved } = puzzleState;

  function choose(optionId: string) {
    if (solved) return;
    patchState(s => ({ ...s, selectedOptionId: optionId }));

    if (optionId === correctOptionId) {
      patchState(s => ({ ...s, solved: true }));
      if (grantsItem) onGrantItem(grantsItem);
      onSolve();
    }
  }

  if (solved) {
    return (
      <p className="puzzle-solved-msg">
        <i className="fa-solid fa-circle-check" aria-hidden="true" /> The frame is questioned.
        {grantsItem && (
          <span className="puzzle-item-grant">
            {' '}<i className="fa-solid fa-key" aria-hidden="true" /> Frame key acquired.
          </span>
        )}
      </p>
    );
  }

  return (
    <div className="puzzle-frame-question">
      <p className="puzzle-narrative">
        The scoreboard offers you three actions. Choose the one that leads outside the frame.
      </p>
      <ul className="puzzle-frame-question__options">
        {options.map(option => {
          const isSelected = selectedOptionId === option.id;
          const isWrong = isSelected && option.id !== correctOptionId;
          return (
            <li key={option.id}>
              <button
                className={[
                  'puzzle-frame-question__option',
                  isSelected ? 'puzzle-frame-question__option--selected' : '',
                  isWrong ? 'puzzle-frame-question__option--wrong' : '',
                ].filter(Boolean).join(' ')}
                type="button"
                onClick={() => choose(option.id)}
              >
                <i className={`fa-solid fa-${option.icon} puzzle-frame-question__icon`} aria-hidden="true" />
                <div className="puzzle-frame-question__text">
                  <strong className="puzzle-frame-question__label">{option.label}</strong>
                  <span className="puzzle-frame-question__desc">{option.description}</span>
                </div>
                {isWrong && (
                  <i className="fa-solid fa-xmark puzzle-frame-question__wrong-mark" aria-hidden="true" />
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
